/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_LabelInputs */

const en_contact_label = /** @type {(inputs: Contact_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact`)
};

const lv_contact_label = /** @type {(inputs: Contact_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakti`)
};

/**
* | output |
* | --- |
* | "Contact" |
*
* @param {Contact_LabelInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const contact_label = /** @type {((inputs?: Contact_LabelInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_LabelInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_contact_label(inputs)
	return en_contact_label(inputs)
});